import { enUS } from "date-fns/locale";
import { format } from "date-fns";

export const extractDateFromISOString = (date: string) => date.split("T")[0];

// Safe date extraction that avoids timezone conversion issues
export const extractDateFromDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDate = (date: string) =>
  format(new Date(date), "EEE d MMM yyyy", { locale: enUS });
